var React = require('react');

function ArrowForwardInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 3.426l5.657 5.657L11 14.74m5.657-5.657H.5"}));
}

ArrowForwardInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","stroke":"#000","fill":"none"};

module.exports = ArrowForwardInline;

ArrowForwardInline.default = ArrowForwardInline;
